import { createI18n } from 'vue-i18n'

import qjtLocale from './qjt'
import zcLocale from './zc'

const messages = {
  qjt: {
    ...qjtLocale
  },
  zc: {
    ...zcLocale
  }
}

// 创建 i18n 实例
const i18n = createI18n({
  locale: 'qjt',
  messages
});

export default i18n
